<template>
  <el-dialog
    class="subscribe-chain-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <div class="subscribe-body">
      <div class="body-top">
        <div class="chain-origin-title">
          <span>区块链来源</span>
        </div>
        <el-radio-group v-model="isExternal" @input="handleChainOriginChanged">
          <el-radio :label="false">平台内创建</el-radio>
          <el-radio :label="true"
            >平台外创建
            <el-tooltip
              effect="dark"
              content="仅支持AuthType属性为permissionedWithCert的链"
              placement="top"
            >
              <span class="el-icon-warning-outline"></span>
            </el-tooltip>
          </el-radio>
        </el-radio-group>
      </div>
      <div class="body-bottom">
        <div class="body-left">
          <el-form
            ref="editForm"
            :label-position="labelPosition"
            :label-width="`${adaptationVars.formLabelWidth}px`"
            :model="editForm"
            :rules="editRules"
            :validate-on-rule-change="false"
          >
            <template v-if="isExternal">
              <el-form-item label="区块链ID" prop="ChainId">
                <el-input
                  v-model="editForm.ChainId"
                  placeholder="请输入外部链ID"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="共识类型" prop="Consensus">
                <el-select
                  v-model="editForm.Consensus"
                  placeholder="请选择外部链的共识类型"
                  clearable
                  class="auto-width"
                >
                  <el-option
                    v-for="item in consensusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="区块链ID" prop="ChainId">
                <el-select
                  v-model="editForm.ChainId"
                  placeholder="请输入"
                  clearable
                  class="auto-width"
                  @change="handleSelectChainId"
                >
                  <el-option
                    v-for="item in chainIdOptions"
                    :key="item.Id"
                    :label="item.ChainId"
                    :value="item.ChainId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
            <el-form-item v-if="isDposChain" label="管理员名称" prop="AdminName">
              <el-select
                v-model="editForm.AdminName"
                placeholder="请选择管理员"
                clearable
                class="auto-width"
              >
                <el-option
                  v-for="item in adminOptions"
                  :key="item.AdminName"
                  :label="item.AdminName"
                  :value="item.AdminName"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="isDposChain" label="节点RPC地址" prop="NodeID">
              <el-select
                v-model="editForm.NodeID"
                placeholder="请选择节点RPC地址"
                clearable
                class="auto-width"
              >
                <el-option
                  v-for="item in nodeOptions"
                  :key="item.NodeName"
                  :label="`${item.NodeIP}:${item.NodeRpcPort}`"
                  :value="`${item.NodeIP}:${item.NodeRpcPort}`"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="isDposChain" label="节点RPC覆写地址" prop="NodeRpcAddress">
              <el-input
                v-model="editForm.NodeRpcAddress"
                placeholder="如需覆盖节点RPC地址请填写，例:127.0.0.1:11302"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="!isDposChain" label="组织名称" prop="OrgId">
              <el-select
                v-model="editForm.OrgId"
                placeholder="请选择"
                clearable
                class="auto-width"
                @change="handleSelectOrg"
              >
                <el-option
                  v-for="item in orgOptions"
                  :key="item.OrgId"
                  :label="item.OrgName"
                  :value="item.OrgId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="!isDposChain" label="节点RPC地址" prop="NodeRpcAddress">
              <el-input
                v-model="editForm.NodeRpcAddress"
                placeholder="例:127.0.0.1:11302"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="!isDposChain" label="用户名称" prop="UserName">
              <el-select
                v-model="editForm.UserName"
                placeholder="请选择"
                clearable
                class="auto-width"
                @focus="validateOrg"
              >
                <el-option
                  v-for="item in userOptions"
                  :key="item.UserName"
                  :label="item.UserName"
                  :value="item.UserName"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区块链简介" prop="Summary">
              <el-input v-model="editForm.Summary" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="是否开启TLS" prop="Tls">
              <el-switch v-model="editForm.Tls" inactive-color="#A7B0B7"> </el-switch>
            </el-form-item>
          </el-form>
        </div>
        <div class="body-right">
          <p>
            1.
            请确保本处上传的组织证书、用户证书、用户私钥、节点信息都属于要订阅链，且节点信息和用户信息都归属于所填写的组织名下；
          </p>
          <p>2. 推荐填写所要订阅链的共识节点的IP和端口，并确保网络畅通；</p>
          <p>3. 如果您的节点同时参与了多条链，请根据区块链ID区分你要订阅具体那条链；</p>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'SubscribeChain', 
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  props: {
    chainIdOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      disabled: false,
      title: '',
      labelPosition: 'left',
      isExternal: false,
      editForm: {
        NodeRpcAddress: '',
        OrgId: '',
        UserName: '',
        ChainId: '',
        Consensus: '',
        Summary: '',
        AdminName: '',
        NodeID: '',
        Tls: true,
        ChainMode: ''
      },
      title1: '组织CA证书',
      title2: '用户证书',
      title3: '用户私钥',
      orgOptions: [],
      userOptions: [],
      isEdit: false,
      adminOptions: [],
      nodeOptions: [],
      consensusOptions: [
        {
          label: 'SOLO',
          value: 0
        },
        {
          label: 'TBFT',
          value: 1
        },
        {
          label: 'MAXBFT',
          value: 3
        },
        {
          label: 'RAFT',
          value: 4
        }
      ],
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  computed: {
    isDposChain: function() {
      let chainID = this.editForm.ChainId
      let isDPos = this.chainIdOptions.some(e => e.ChainId == chainID && e.Consensus == 'DPOS')
      return isDPos
    },
    editRules: function() {
      let validateAddr = (rule, value, callback) => {
        let reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}((2[0-4]\d|25[0-5]|[01]?\d\d?)\:)(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[0-5]\d{4}|[1-9]\d{0,3})$/
        if (value === '') {
          callback(new Error('请输入节点RPC地址'))
        } else if (!reg.test(value)) {
          callback(new Error('地址格式不正确'))
        } else {
          callback()
        }
      }
      if (this.isDposChain) {
        return {
          NodeID: [{ required: true, message: '请选择节点RPC地址', trigger: ['blur', 'change'] }],
          //NodeRpcAddress: [{ required: true, validator: validateAddr, trigger: ['blur', 'change'] }],
          AdminName: [{ required: true, message: '请选择管理员', trigger: ['blur', 'change'] }],
          Tls: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
          ChainId: [{ required: true, message: '请输入区块链ID', trigger: ['blur', 'change'] }],
          Summary: [{ required: true, message: '请输入区块链简介', trigger: ['blur', 'change'] }]
        }
      } else {
        if (this.isExternal) {
          return {
            OrgId: [{ required: true, message: '请选择组织', trigger: ['blur', 'change'] }],
            //NodeRpcAddress: [{ required: true, validator: validateAddr, trigger: ['blur', 'change'] }],
            Consensus: [
              { required: true, message: '请选择外部链的共识类型', trigger: ['blur', 'change'] }
            ],
            UserName: [{ required: true, message: '请选择用户', trigger: ['blur', 'change'] }],
            Tls: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
            ChainId: [{ required: true, message: '请输入区块链ID', trigger: ['blur', 'change'] }],
            Summary: [{ required: true, message: '请输入区块链简介', trigger: ['blur', 'change'] }]
          }
        } else {
          return {
            OrgId: [{ required: true, message: '请选择组织', trigger: ['blur', 'change'] }],
            //NodeRpcAddress: [{ required: true, validator: validateAddr, trigger: ['blur', 'change'] }],
            UserName: [{ required: true, message: '请选择用户', trigger: ['blur', 'change'] }],
            Tls: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
            ChainId: [{ required: true, message: '请输入区块链ID', trigger: ['blur', 'change'] }],
            Summary: [{ required: true, message: '请输入区块链简介', trigger: ['blur', 'change'] }]
          }
        }
      }
    }
  },
  methods: {
    getOptions() {
      //组织
      this.$apis.certificate.getOrgList({ limit: 50, offset: 0, certType: 0 }).then(res => {
        if (res.data && res.data.items) {
          let hasObj = {}
          this.orgOptions = res.data.items.reduce((result, cur) => {
            if (!hasObj[cur['OrgName']]) {
              hasObj[cur['OrgName']] = true
              result.push(cur)
            }
            return result
          }, [])
        }
      })
    },
    handleSelectChainId(ChainID) {
      let isDPos = this.chainIdOptions.some(e => e.ChainId == ChainID && e.Consensus == 'DPOS')

      let chainMode = ''
      for (let i = 0; i < this.chainIdOptions.length; i++) {
        if (ChainID == this.chainIdOptions[i].ChainId) {
          chainMode = this.chainIdOptions[i].ChainMode
          break
        }
      }

      if (isDPos) {
        //获取管理员列表
        this.$apis.certificate.getDposChainAdmins({ ChainID }).then(res => {
          if (res.data && res.data.items) {
            this.adminOptions = res.data.items
          }
        })

        //获取节点用户列表
        this.$apis.certificate.getDposChainNodes({ ChainID }).then(res => {
          if (res.data && res.data.items) {
            this.nodeOptions = res.data.items
          }
        })
      }

      this.editForm.ChainMode = chainMode
      this.$nextTick(() => {
        this.$refs.editForm.clearValidate()
      })
    },
    handleSelectOrg(OrgId) {
      this.$apis.certificate.getUserListByOrg({ OrgId }).then(res => {
        if (res.data && res.data.items) {
          this.editForm.UserName = ''
          this.userOptions = res.data.items
        }
      })
    },
    validateOrg() {
      if (this.$utils.isEmpty(this.editForm.OrgId)) {
        this.$message.warning('请先选择组织名称！')
        return
      }
    },
    handleCancel() {
      //this.$refs.uploadCa.clear()
      //this.$refs.uploadCertificate.clear()
      //this.$refs.uploadKey.clear()
      this.editForm = {
        NodeRpcAddress: '',
        OrgId: '',
        UserName: '',
        ChainId: '',
        Summary: '',
        AdminName: '',
        NodeID: '',
        Tls: true,
        ChainMode: ''
      }
      this.$refs.editForm.clearValidate()
      this.disabled = false
      this.isEdit = false
      this.orgOptions = []
      this.userOptions = []
      this.dialogVisible = false
    },
    handleOpen(data) {
      this.getOptions()
      if (data) {
        this.title = '编辑订阅区块链'
        this.isEdit = true
        this.editForm = data
      } else {
        this.title = '新增订阅区块链'
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.editForm.clearValidate()
      })
    },
    handleOk() {
      //let file = this.$refs.uploadCa.getFileRaw()
      //let file1 = this.$refs.uploadCertificate.getFileRaw()
      //let file2 = this.$refs.uploadKey.getFileRaw()
      this.disabled = true
      let self = this
      this.$refs.editForm.validate(valid => {
        if (valid) {
          let sendData = self.transFormData()

          if (self.isEdit) {
            self.$apis.home.updateSubscribe(sendData).then(res => {
              self.$emit('update:list')
              self.handleCancel()
            })
          } else {
            self.$apis.chain
              .subscribeChain(sendData)
              .then(res => {
                self.$emit('update:list')
                self.$message.success('订阅成功！')
                self.handleCancel()
              })
              .catch(err => {
                self.disabled = false
                return
              })
          }
        } else {
          self.$message.warning('请填写内容')
          self.disabled = false
          return
        }
      })
    },
    transFormData() {
      let formData = {
        ChainId: this.editForm.ChainId,
        NodeRpcAddress: this.editForm.NodeRpcAddress,
        ChainMode: this.editForm.ChainMode,
        OrgId: this.editForm.OrgId,
        UserName: this.editForm.UserName,
        Tls: this.editForm.Tls,
        Summary: this.editForm.Summary
      }
      if (this.isDposChain) {
        formData.AdminName = this.editForm.AdminName
        formData.NodeRpcAddress = this.editForm.NodeID
        //如果有覆写地址，则覆盖选择的RPC地址
        if (this.editForm.NodeRpcAddress) {
          formData.NodeRpcAddress = this.editForm.NodeRpcAddress
        }
      } 

      //当为外部链时，传入共识算法，ChainMode设置为permissionedWithCert
      formData.isExternal = this.isExternal;
      if (this.isExternal) {
        formData.ChainMode = 'permissionedWithCert';
        formData.Consensus = this.editForm.Consensus;
      }

      //当为外部链时，传入共识算法，ChainMode设置为permissionedWithCert
      formData.isExternal = this.isExternal
      if (this.isExternal) {
        formData.ChainMode = 'permissionedWithCert'
        formData.Consensus = this.editForm.Consensus
      }

      let sendData = JSON.parse(JSON.stringify(formData))
      sendData.Tls = this.editForm.Tls ? 0 : 1

      return sendData
    },
    handleChainOriginChanged(val) {
      this.$nextTick(() => {
        this.$refs.editForm.clearValidate()
      })
    }
  }
}
</script>

<style scoped lang="scss">

@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.subscribe-chain-dialog {
  @include adaptation(
    (
      --left-part-width: 560px
    )
  );
  --right-part-width: calc(var(--common-dialog-large-width) - var(--left-part-width) - var(--base-size-24) * 3);
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }
  .subscribe-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: var(--base-size-16);

    .body-top {
      display: flex;
      flex-direction: column;
      padding-bottom: var(--base-size-8);
      margin-bottom: var(--base-size-8);
      border-bottom: var(--base-border-width) solid var(--base-border-color-light);

      .chain-origin-title {
        padding-bottom: var(--base-size-8);
      }
    }

    .body-bottom {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .body-left {
        width: var(--left-part-width);
        border-right: var(--base-border-width) solid var(--base-border-color-light);
        padding-right: var(--base-size-24);
      }

      .body-right {
        width: var(--right-part-width);
        border: var(--base-border-width) solid var(--base-border-color-light);
        padding: var(--base-size-48) var(--base-size-8);
        border-radius: var(--base-border-radius);
        font-size: var(--base-font-size-common);
        line-height: 1.5;
        color: var(--base-color-text-regular);
      }
    }
  }
}
</style>
